// src/hooks/useOperatorClaims.js
import { useState, useEffect, useCallback } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebase';

/**
 * Operator claims for US-06/US-07/US-12 admin surfaces (not legacy role: admin).
 * @returns {{ isSupportAdmin: boolean, isSuperAdmin: boolean, isOperator: boolean, loading: boolean, refreshClaims: () => Promise<void> }}
 */
export const useOperatorClaims = () => {
  const [user, authLoading] = useAuthState(auth);
  const [isSupportAdmin, setIsSupportAdmin] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  const loadClaims = useCallback(async (forceRefresh = false) => {
    if (!user) {
      setIsSupportAdmin(false);
      setIsSuperAdmin(false);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const tokenResult = await user.getIdTokenResult(forceRefresh);
      const claims = tokenResult.claims || {};
      setIsSupportAdmin(claims.support_admin === true);
      setIsSuperAdmin(claims.super_admin === true);
    } catch (error) {
      console.error('[useOperatorClaims] failed to read claims:', error);
      setIsSupportAdmin(false);
      setIsSuperAdmin(false);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    loadClaims(false);
  }, [loadClaims]);

  const refreshClaims = useCallback(async () => {
    await loadClaims(true);
  }, [loadClaims]);

  return {
    isSupportAdmin,
    isSuperAdmin,
    isOperator: isSupportAdmin || isSuperAdmin,
    loading: loading || authLoading,
    refreshClaims,
  };
};
